var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8037 7.24295L18.8366 6.28737C18.575 6.02568 18.1426 6.02568 17.8696 6.28737L13.0455 11.1113L8.13052 6.19635C7.86873 5.93455 7.43638 5.93455 7.16344 6.19635L6.19635 7.16343C5.93455 7.42511 5.93455 7.85745 6.19635 8.13051L11.1001 13.0342L6.28737 17.8696C6.02568 18.1313 6.02568 18.5636 6.28737 18.8367L7.25446 19.8037C7.51614 20.0654 7.94848 20.0654 8.22154 19.8037L13.0455 14.9797L17.8696 19.8037C18.1312 20.0654 18.5636 20.0654 18.8366 19.8037L19.8037 18.8367C20.0654 18.575 20.0654 18.1426 19.8037 17.8696L14.9683 13.0456L19.7924 8.22164C20.0654 7.94835 20.0654 7.51601 19.8037 7.24295Z",
    fill: "#FBA919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.13309c0bd8723619224f3aa04614deaf.svg";
export { ForwardRef as ReactComponent };